var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuConcierge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line/trending-up-outline",
    clipPath: "url(#clip0_3198_99036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trending-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7028 6.9596L20.7001 6.9797V12C20.7001 12.1856 20.6264 12.3637 20.4951 12.495C20.3638 12.6262 20.1858 12.7 20.0001 12.7C19.8144 12.7 19.6364 12.6262 19.5051 12.495C19.3738 12.3637 19.3001 12.1856 19.3001 12V8.8886L14.5323 14.4548C14.4251 14.5801 14.2771 14.6636 14.1144 14.6905C13.952 14.7174 13.7853 14.6861 13.6437 14.6023L9.15407 11.9106L4.53963 17.4479C4.47382 17.5269 4.39135 17.5906 4.29819 17.6341C4.20504 17.6777 4.10342 17.7002 4.00059 17.7L3.99951 17.7C3.83598 17.7003 3.6775 17.6434 3.55157 17.539C3.48069 17.4803 3.4221 17.4081 3.37915 17.3267C3.33621 17.2452 3.30975 17.1561 3.3013 17.0644C3.29284 16.9727 3.30256 16.8803 3.32989 16.7924C3.35722 16.7044 3.40163 16.6228 3.46057 16.552L8.46057 10.552C8.56713 10.4239 8.7161 10.3378 8.88034 10.3096C9.04457 10.2813 9.21349 10.3126 9.35672 10.3978L13.8946 13.0975L18.4785 7.69999H15.0001C14.8144 7.69999 14.6364 7.62624 14.5051 7.49496C14.3738 7.36369 14.3001 7.18564 14.3001 6.99999C14.3001 6.81434 14.3738 6.63629 14.5051 6.50501C14.6364 6.37374 14.8144 6.29999 15.0001 6.29999H19.9291C19.9552 6.31565 19.9795 6.33427 20.0014 6.35551L20.0887 6.43999H20.3531C20.3769 6.45115 20.3996 6.46472 20.4208 6.48049L20.4343 6.4906L20.5386 6.55145C20.5633 6.57654 20.5849 6.60446 20.603 6.63463L20.6112 6.6482L20.6207 6.66084C20.6428 6.69004 20.6628 6.7207 20.6807 6.75263C20.6914 6.77814 20.6989 6.80486 20.7031 6.83221C20.7087 6.87449 20.7086 6.91734 20.7028 6.9596Z",
    fill: "#46474C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3198_99036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuConcierge);
export default __webpack_public_path__ + "static/media/icon_menu_concierge.d2ca27d3a60e4ca2e67a7210e617c339.svg";
export { ForwardRef as ReactComponent };